const HTTP_PROTOCOLS = new Set(["http:", "https:"]);

const normalizeHttpUrl = (value, baseUrl = "") => {
  const text = typeof value === "string" ? value.trim() : "";
  if (!text) return "";

  try {
    let candidate = text;

    if (/^\/[^/]/.test(candidate)) {
      if (!baseUrl) return "";
      candidate = new URL(candidate, baseUrl).href;
    } else if (candidate.startsWith("//")) {
      candidate = `https:${candidate}`;
    } else if (!/^[a-z][a-z\d+.-]*:/i.test(candidate)) {
      candidate = `https://${candidate}`;
    }

    const url = new URL(candidate);
    return HTTP_PROTOCOLS.has(url.protocol) ? url.href : "";
  } catch {
    return "";
  }
};

export const getVerificationReturnUrl = (session) => {
  const siteUrl = normalizeHttpUrl(
    session?.siteUrl ||
      session?.site_url ||
      session?.siteConfig?.siteUrl ||
      session?.siteConfig?.site_url,
  );
  const successUrl =
    session?.successUrl ||
    session?.success_url ||
    session?.siteConfig?.successUrl ||
    session?.siteConfig?.success_url;

  return (
    normalizeHttpUrl(successUrl) ||
    normalizeHttpUrl(session?.returnUrl || session?.return_url, siteUrl) ||
    siteUrl
  );
};
